import React from 'react';
import { CircularProgress } from '@mui/material';

const LoadingComponent: React.FC = () => {
    return (
        <div className='flex w-full h-screen items-center justify-center bg-white'>
            <CircularProgress />
        </div>
    );
};

export default LoadingComponent; 